export default __webpack_public_path__ + "static/media/open-ad.ca9080d5.svg";